import React, { useMemo } from "react";
import { getClassConditionalAppend, getColors, getContainerClassPerMaxWidth } from "../../utils";
import { Container, ContainerFW } from "../global";
import { FreeContentDisplay } from "./FreeContentDisplay/FreeContentDisplay";
import { StatSection } from "./StatSection/StatSection";
import { TradingViewSection } from "./TradingViewSection/TradingViewSection";
export const M38StatsAndTrustPilot = ({ stats, backgroundColor, containerMaxWidth, trustPilotScript, tradingViewEvaluation, tradingViewLogoUrl, tradingViewMarks, showTradingViewSection, borderAroundTrustPilot }) => {
    const { bgColor, textColor } = getColors(backgroundColor);
    const containerMaxWidthClass = getContainerClassPerMaxWidth(containerMaxWidth);
    const containerExtraClass = getClassConditionalAppend(containerMaxWidthClass);
    const WrapperWithBorder = ({ children }) => {
        if (borderAroundTrustPilot) {
            return React.createElement("div", { className: "stats-and-trust-pilot-root__brokerWrapper with-border-around-TP" }, children);
        }
        return React.createElement("div", { className: "stats-and-trust-pilot-root__brokerWrapper" }, children);
    };
    const checkStats = (stats) => Array.isArray(stats) && stats.length !== 0;
    const checkHasSeparator = (showTradingViewSection, trustPilotScript) => showTradingViewSection && trustPilotScript;
    const hasStats = checkStats(stats);
    const hasSeparator = checkHasSeparator(showTradingViewSection, trustPilotScript);
    const HandleContainerWithBorder = useMemo(() => {
        if (bgColor === "#FFFFFF") {
            return React.createElement("div", { className: `brokerWrapper__colouredBorder ${!hasStats ? "brokerWrapper__colouredBorder--no-offset" : ""}` });
        }
        return React.createElement(React.Fragment, null);
    }, [bgColor, hasStats]);
    return (React.createElement(ContainerFW, { className: containerExtraClass, backgroundColor: bgColor },
        React.createElement(Container, { className: containerExtraClass },
            React.createElement("div", { className: "stats-and-trust-pilot-root" },
                hasStats && React.createElement("div", { className: "stats-and-trust-pilot-root__statsWrapper" }, stats.map((stat) => (React.createElement(StatSection, { key: `unique${stat.title}`, ...stat, textColor: textColor })))),
                React.createElement(WrapperWithBorder, null,
                    showTradingViewSection && React.createElement(TradingViewSection, { evaluation: tradingViewEvaluation, logoUrl: tradingViewLogoUrl, marks: tradingViewMarks, textColor: textColor }),
                    hasSeparator && React.createElement("div", { className: "brokerWrapper__pipeSeparator" }),
                    trustPilotScript && React.createElement(FreeContentDisplay, { scriptContent: trustPilotScript })))),
        HandleContainerWithBorder));
};
